import React from 'react';
import moment from "moment";

import { Grid } from '@material-ui/core';

import NonFieldErrors from '../../../../../components/AssetModal/components/NonFieldErrors';
import {decimalStrToNumber} from "../../../../../utils/utils";
import SelectFormElementV2
  from "../../../../RiskProfiling/components/StepContent/components/formElement/SelectFormElementV2";
import InputFormElement
  , {CurrencyNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";
import {INSURANCE_CATEGORY, newDesignInputCustomClassesViewOnly} from "../../../constants";
import {PercentageNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement/InputFormElement";
import {choiceValue, dateToMoment, momentToDate} from "../../utils";
import {END_DATE_SHOULD_BE_AFTER_START} from "../../../../Trades/constants";


const InsuranceForm = (props) => {

  const {
    handleFormChange,
    defaults,
    errors,
    viewOnly
  } = props;

  const [model, setModel] = React.useState({
    type_of_insurance: choiceValue(defaults.type_of_insurance || defaults.sub_category),
    name: defaults.name,
    company_name: defaults.company_name,
    acquisition_date: dateToMoment(defaults.acquisition_date),
    final_duration: dateToMoment(defaults.final_duration),
    value: decimalStrToNumber(defaults.value),
    surrender_valuation_date: dateToMoment(defaults.surrender_valuation_date),
    monthly_amount: decimalStrToNumber(defaults.monthly_amount),
    interest_rate:  decimalStrToNumber(defaults.interest_rate),
    collateral: decimalStrToNumber(defaults.collateral),
    collateral_valuation_date: dateToMoment(defaults.collateral_valuation_date),
    updated: dateToMoment(defaults.updated),
  });

  React.useEffect(() => {
    handleFormChange && handleFormChange({
      ...model,
      acquisition_date: momentToDate(model.acquisition_date),
      final_duration: momentToDate(model.final_duration),
      surrender_valuation_date: momentToDate(model.surrender_valuation_date),
      collateral_valuation_date: momentToDate(model.collateral_valuation_date),
    });
  }, [model]);

  const handleModelChange = (field) => (value) => {
    setModel({
      ...model,
      [field]: value
    })
  };

  const inputClasses = viewOnly ? newDesignInputCustomClassesViewOnly : newDesignInputCustomClasses;

  return (
    <>
      {!viewOnly && (
        <Grid item xs={12}>
          <SelectFormElementV2
            dataId={'category-input'}
            label="Kategorie"
            value={model.type_of_insurance}
            options={INSURANCE_CATEGORY.subCategories}
            onChange={handleModelChange('type_of_insurance')}
            disabled={viewOnly}
            required
            newDesign
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Name / Bezeichnung'}
          required={!viewOnly}
          dataId={'name-input'}
          value={model.name}
          error={errors.name}
          onChange={handleModelChange('name')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Gesellschaft'}
          dataId={'company_name-input'}
          value={model.company_name}
          error={errors.company_name}
          required={!viewOnly}
          onChange={handleModelChange('company_name')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <CalendarFormElement
          label="Erwerbsdatum"
          dataId={'acquisition_date-input'}
          value={model.acquisition_date}
          error={errors.acquisition_date}
          onChange={handleModelChange('acquisition_date')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <CalendarFormElement
          label="Laufzeit bis"
          minDate={model.acquisition_date || undefined}
          minError={END_DATE_SHOULD_BE_AFTER_START}
          dataId={'final_duration-input'}
          value={model.final_duration}
          error={errors.final_duration}
          onChange={handleModelChange('final_duration')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputFormElement
          label="Rückkaufswert"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.value}
          error={errors.value}
          dataId={'value-input'}
          onChange={handleModelChange('value')}
          required={!viewOnly}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <CalendarFormElement
          label="Bewertungsdatum"
          disableFuture
          dataId={'value_date-input'}
          value={model.surrender_valuation_date}
          error={errors.surrender_valuation_date}
          onChange={handleModelChange('surrender_valuation_date')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputFormElement
          label="Monatliche Einzahlung"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.monthly_amount}
          error={errors.monthly_amount}
          dataId={'monthly_amount-input'}
          onChange={handleModelChange('monthly_amount')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputFormElement
          label="Verzinsung"
          inputComponent={PercentageNumberFormat}
          inputProps={{inputProps: {allowNegative: false, isAllowed: (values) => {
            const {floatValue} = values;
            return !floatValue || floatValue <= 100;
          }}}}
          value={model.interest_rate}
          error={errors.interest_rate}
          onChange={handleModelChange('interest_rate')}
          dataId={'interest_rate-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputFormElement
          label="Garantie"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.collateral}
          error={errors.collateral}
          onChange={handleModelChange('collateral')}
          dataId={'collateral-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <CalendarFormElement
          label="Garantiedatum"
          disableFuture
          value={model.collateral_valuation_date}
          error={errors.collateral_valuation_date}
          dataId={'collateral_valuation_date-input'}
          onChange={handleModelChange('collateral_valuation_date')}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <CalendarFormElement
          label="Stand vom"
          value={model.updated || moment()}
          dataId={'updated-input'}
          disabled
          required={!viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      {!!errors['non_field_errors'] && <NonFieldErrors errors={errors['non_field_errors']}/>}
    </>
  )
};

InsuranceForm.defaultProps = {
  defaults: {},
  errors: {}
};

export default InsuranceForm;